import { render, staticRenderFns } from "./dynamic-collection.vue?vue&type=template&id=818b837e&scoped=true&"
import script from "./dynamic-collection.vue?vue&type=script&lang=js&"
export * from "./dynamic-collection.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-collection.vue?vue&type=style&index=0&id=818b837e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818b837e",
  null
  
)

export default component.exports